import React, { useState } from 'react'
import { Strategy } from '../../list/types'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CImage,
  CRow,
} from '@coreui/react-pro'
import { ConfirmModal } from '../../atoms/confirmModal'
import {
  deleteAchievementStrategy,
  resetImageStrategy,
  submitUnPublishStrategy,
} from '../model'
import { path, role } from '../../../../../libs'
import { SetSortingModal } from '../../atoms/setSortingModal'
import { AddAchievementModal } from '../../atoms/addAchievementModal'
import { cilX } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { env } from '../../../../../libs/constants'
import { useStore } from 'effector-react'
import { $userRole } from '../../../../../features/user'
import { Guard } from '../../../../../features/session/guard'
import { AddInvestorsModal } from 'src/pages/copytrade/strategies/details/addInvestors'

type TProps = {
  data: Strategy
}
export const StrategyGeneral: React.FC<TProps> = ({ data }) => {
  const userRole = useStore($userRole)
  const [isOpenModal, setOpenModal] = useState({
    isOpenSortingModal: false,
    isOpenConfirmModal: false,
    addAchievementModal: false,
    isOpenAddInvestorsModal: false,
  })

  const {
    status,
    id,
    title,
    description,
    account,
    commission,
    clientId,
    accountId,
    imageLink,
    aiAssessment,
    aiMagic,
    achievements,
    investors,
    totalInvestors,
    percentCommission,
    numAdditionalInvestors,
  } = data

  const toggleModals = (name: string, value: boolean) => {
    setOpenModal((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  return (
    <CCol xs={12}>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol className=" d-flex align-items-baseline justify-content-end">
              <Guard permission="edit_strategy">
                <CButton
                  color="secondary"
                  className="me-2"
                  href={path.copytrade.strategies.edit(String(id))}
                  disabled={
                    userRole != undefined &&
                    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                      userRole.indexOf(role.clientSupport.supportManager()) >=
                        0)
                  }
                >
                  Edit
                </CButton>
                <CButton
                  color="light"
                  className="me-2"
                  onClick={() => toggleModals('isOpenAddInvestorsModal', true)}
                  disabled={
                    userRole != undefined &&
                    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                      userRole.indexOf(role.clientSupport.supportManager()) >=
                        0)
                  }
                >
                  Add Investors
                </CButton>
                <CButton
                  color="warning"
                  className="me-2"
                  onClick={() => resetImageStrategy()}
                  disabled={
                    userRole != undefined &&
                    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                      userRole.indexOf(role.clientSupport.supportManager()) >=
                        0)
                  }
                >
                  Reset image
                </CButton>
                <CButton
                  color="success"
                  className="me-2"
                  onClick={() => toggleModals('addAchievementModal', true)}
                  disabled={
                    userRole != undefined &&
                    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                      userRole.indexOf(role.clientSupport.supportManager()) >=
                        0)
                  }
                >
                  Achievement
                </CButton>
                <CButton
                  color="danger"
                  className="me-2"
                  onClick={() => toggleModals('isOpenConfirmModal', true)}
                  disabled={
                    userRole != undefined &&
                    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                      userRole.indexOf(role.clientSupport.supportManager()) >=
                        0)
                  }
                >
                  Unpublish
                </CButton>
                <CButton
                  color="info"
                  className="me-2"
                  onClick={() => toggleModals('isOpenSortingModal', true)}
                  disabled={
                    userRole != undefined &&
                    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                      userRole.indexOf(role.clientSupport.supportManager()) >=
                        0)
                  }
                >
                  Set sorting
                </CButton>
              </Guard>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm={8}>
              {imageLink && (
                <div className="mt-2">
                  <CImage
                    rounded
                    thumbnail
                    src={imageLink}
                    width={200}
                    height={200}
                  />
                </div>
              )}
              <div className="mt-2">
                <span className="text-muted">Status:</span> {status}
              </div>
              <div className="mt-2">
                <span className="text-muted">Name:</span> {title}
              </div>
              <div className="mt-2">
                <span className="text-muted">Description:</span> {description}
              </div>
              <div className="mt-2">
                <span className="text-muted">ClientId:</span>{' '}
                <a
                  href={path.clients.details(String(clientId))}
                  target={'_blank'}
                >
                  {clientId}
                </a>
              </div>
              <div className="mt-2">
                <span className="text-muted">AccountId:</span> {accountId}
              </div>
              <div className="mt-2">
                <span className="text-muted">Commission:</span> {commission}
              </div>
              <div className="mt-2">
                <span className="text-muted">Commission %:</span>{' '}
                {percentCommission * 100}
              </div>
              <div className="mt-2">
                <span className="text-muted">MT Login:</span>{' '}
                {account?.accountPlatform} {account?.mtLogin}
              </div>
              <div className="mt-2">
                <span className="text-muted">Balance:</span> {account?.balance}
              </div>
              <div className="mt-2">
                <span className="text-muted">AI Assessment:</span>{' '}
                {aiAssessment}
              </div>
              <div className="mt-2">
                <span className="text-muted">Link to the card:</span>{' '}
                <a
                  target={'_blank'}
                  href={
                    env.hwOnline +
                    '/user/social-trading/copytrade/all-strategies/strategy/' +
                    id
                  }
                >
                  {id}
                </a>
              </div>
              <div className="mt-2">
                <span className="text-muted">Active Investors:</span>{' '}
                {investors + numAdditionalInvestors}
              </div>
              <div className="mt-2">
                <span className="text-muted">Total Investors:</span>{' '}
                {totalInvestors}
              </div>
              {achievements.length > 0 && (
                <div className="mt-2">
                  <span>Achievements</span>
                  <div className="ms-3 d-flex gap-2">
                    {achievements.map((item: any) => (
                      <>
                        <div>{item.achievement.title}</div>
                        <div>
                          <CIcon
                            className="text-danger"
                            role="button"
                            icon={cilX}
                            onClick={() =>
                              deleteAchievementStrategy({
                                achievementId: item.achievement.id,
                                strategyId: id,
                              })
                            }
                          />
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              )}
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <ConfirmModal
        isOpen={isOpenModal.isOpenConfirmModal}
        onSubmit={() => {
          submitUnPublishStrategy()
          toggleModals('isOpenConfirmModal', false)
        }}
        onCancel={() => toggleModals('isOpenConfirmModal', false)}
      />
      <SetSortingModal
        data={{
          aiAssessment: aiAssessment,
          aiMagic: aiMagic,
        }}
        isOpen={isOpenModal.isOpenSortingModal}
        onCancel={() => toggleModals('isOpenSortingModal', false)}
      />
      <AddAchievementModal
        isOpen={isOpenModal.addAchievementModal}
        onCancel={() => toggleModals('addAchievementModal', false)}
      />
      {isOpenModal.isOpenAddInvestorsModal && (
        <AddInvestorsModal
          isOpen={isOpenModal.isOpenAddInvestorsModal}
          onCancel={() => toggleModals('isOpenAddInvestorsModal', false)}
          data={data}
        />
      )}
    </CCol>
  )
}
